/* eslint-disable jsx-a11y/alt-text */
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import Cookies from "js-cookie";
import {
  saveActiveArRequestsTab,
  saveActiveEmpOnboardTab,
  saveActiveLeaveRequestsTab,
  saveActiveOdRequestsTab,
  saveActivePtAgainstPoTab,
  saveActivePtGeneralTab,
  saveActivePurchaseOrderTab,
  saveActivePurchaseRequestTab,
  saveActivePurchaseTab,
  saveActiveSalaryHeadTab,
  saveActiveSidebarTab,
  saveActiveSiteDetailTab,
  saveNotifications,
  saveNotificationsCount,
  saveSideBarScrollPosition,
  saveUserDetails,
  updateDateFilter,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import { toast } from "react-toastify";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import {
  getCurrentFinancialYear,
  timeAgo,
} from "../../utility/CommonFunctions";
import LineLoader from "../Loaders/LineLoader";
import LogoutModal from "../comman/LogoutModal";
import NotificationDropdown from "./NotificationDropdown";
import { useState } from "react";
import moment from "moment";

export default function UserHeader({
  getNotification,
  notificationCount,
  isloading,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const userDetails = useSelector((state) => state.root.userDetails);
  const notifications = useSelector((state) => state?.root?.notifications);

  const HandleLogout = () => {
    const deviceId = localStorage.getItem("deviceId");

    const options = {
      method: "GET",
    };
    let API = apiUrl?.logout + `?deviceId=${deviceId}`;
    setLogoutLoading(true);
    callApi(API, options).then((response) => {
      setLogoutLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        dispatch(saveUserDetails({}));
        dispatch(saveNotifications([]));
        dispatch(saveNotificationsCount({}));
        dispatch(saveSideBarScrollPosition(0));
        dispatch(saveActiveSidebarTab(-1));
        dispatch(saveActiveSiteDetailTab(1));
        dispatch(saveActiveLeaveRequestsTab(1));
        dispatch(saveActiveArRequestsTab(1));
        dispatch(saveActiveOdRequestsTab(1));
        dispatch(saveActiveEmpOnboardTab(1));
        dispatch(saveActivePurchaseTab(""));
        dispatch(saveActivePurchaseRequestTab(1));
        dispatch(saveActivePurchaseOrderTab(""));
        dispatch(saveActivePtAgainstPoTab("pending"));
        dispatch(saveActivePtGeneralTab("pending"));
        dispatch(saveActiveSalaryHeadTab(1));
        dispatch(
          updateFiltersStates({
            currentPage: 1,
            pageSize: 10,
            count: 0,
            totalPages: 0,
            sortByDate: [
              moment(moment().subtract(30, "days").toDate()).format(
                "YYYY-MM-DD"
              ),
              moment(moment().toDate()).format("YYYY-MM-DD"),
            ],
            year: getCurrentFinancialYear(),
            companyId: "",
            siteId: "",
            department: "",
            designation: "",
            requestType: "",
            stockStatus: "",
            vendorId: "",
            empStatus: "current",
          })
        );
        dispatch(
          updateDateFilter([
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().endOf("month").format("YYYY-MM-DD"),
          ])
        );
        Cookies.remove("token");
        Cookies.remove("refreshToken");
        localStorage.removeItem("token");
        localStorage.removeItem("fcmToken");
        new BroadcastChannel("auth").postMessage({
          type: "logout",
          sourceTabId: window.__TAB_ID,
        });
        window.location.reload();
        navigate(RoutesLink.login);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <header className="header shadow-sm bg-white" style={{ borderBottom: "1px solid #dee2e6", height: "70px" }}>
        <nav className="navbar navbar-expand-lg py-1 h-100">
          <div className="container-fluid">
            <div className="collapse navbar-collapse justify-content-between align-items-stretch">
              <button
                className="btn btn-toggle border-0 d-none"
                id="toggleButton"
                type="button"
              >
                <i className="fas fa-bars" />
              </button>
              <div className="header-nav d-flex align-items-stretch justify-content-between w-100">
                <div className="user d-flex align-items-center gap-2">
                  <img className="user-icon rounded-circle" style={{ width: "32px", height: "32px", objectFit: "cover" }} src={userDetails?.profilePhoto} />

                  <div>
                    <h6 className="title mb-0 fw-bold">{userDetails?.name}</h6>
                    <p className="mb-0 text-muted" style={{ fontSize: "11px" }}>{userDetails?.employeeCode}</p>
                  </div>
                </div>
                <ul className="d-flex align-items-center gap-3 list-unstyled mb-0">
                  {(userDetails?.designationName || userDetails?.departmentName) && (
                    <li className="d-none d-md-block">
                      <p className="title mb-0 text-muted" style={{ fontSize: "15px" }}>
                        <span className="fw-semibold text-primary">{userDetails?.designationName}</span> {userDetails?.designationName && userDetails?.department?.name && <span className="mx-1">|</span>} {userDetails?.department?.name}
                      </p>
                    </li>
                  )}
                  <li>
                    <NotificationDropdown
                      notifications={notifications}
                      notificationCount={notificationCount}
                      isLoading={isloading}
                      onFetch={() => getNotification()}
                      userType={userDetails?.type}
                    />
                  </li>
                  <li>
                    <div className="dropdown">
                      <button
                        className="btn border-0 bg-transparent d-flex align-items-center justify-content-center dropdown-toggle"
                        style={{ width: "32px", height: "32px" }}
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="far fa-user text-primary" style={{ fontSize: "16px" }} />
                      </button>
                      <ul className="dropdown-menu shadow">
                        <li>
                          <a
                            className="dropdown-item"
                            role="button"
                            onClick={() => navigate(RoutesLink?.profile)}
                          >
                            <i className="far fa-user" />
                            Profile
                          </a>
                        </li>
                        {/* <li>
                          <a className="dropdown-item" href="#">
                            <i className="fas fa-cog" />
                            Setting
                          </a>
                        </li> */}
                        <li>
                          <a
                            className="dropdown-item"
                            role="button"
                            onClick={toggle}
                          >
                            <i className="fas fa-door-open" />
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <LogoutModal
        modal={modal}
        toggle={toggle}
        HandleLogout={HandleLogout}
        logoutLoading={logoutLoading}
      />
    </>
  );
}
